export default "__VITE_ASSET__Ddr9soZr__"